// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-d29ad7","sapcnqr-overlay":"sapcnqr-overlay-0ab056","sapcnqr-overlay__content":"sapcnqr-overlay__content-03d3e2"};